import { Tooltip, Button } from "@mui/material"
import { appdata } from "../internalModules"
import { welcomeButtonStyle } from "../Graphics"
import exampleAppData  from '../data/ExampleAppData.json';

type Props = {
  updateApp: Function,
  text?: string,
  tooltip?: string,
  example?: boolean,
  variant?: 'outlined' | 'contained'
}
  
export default function UIButtonNewProject({updateApp, text, tooltip, example, variant}: Props){
  const buttonText = text ? text : 'NEW'
  let tooltipText = tooltip ? tooltip : "Start a new project"

  function handleNewProject() {
    appdata.readJsonFile(JSON.stringify(exampleAppData))
    if(!example){
      appdata.wallTypes.clear()
      appdata.members.clear()
      appdata.scenarios.clear()
    }
    updateApp()
  }

  
  return(
    <Tooltip arrow followCursor title={tooltipText}>
      <Button variant={variant} color='primary' sx={welcomeButtonStyle} component="label" onClick={handleNewProject}>
        {buttonText}
      </Button>
    </Tooltip>
  )
}